<template>
  <v-content style="height: 100%">
    <Header :title="section"></Header>

    <v-layout justify-center mt-5>
      <v-flex pa-4>

        <v-layout justify-end mb-7>
          <v-flex shrink>
            <InputForm :type="section"></InputForm>
          </v-flex>
        </v-layout>

        <!-- Loading overlay -->
        <loading :active.sync="sectionLoaded" :is-full-page="false" loader="bars"></loading>


        <v-layout v-if="section === undefined || section === 'data-and-stats' || section === 'cindex'" justify-center>
          <v-flex>

            <v-tabs v-model="dataTab" @change="onTabChange">
              <v-tab>All</v-tab>
              <v-tab>Overview</v-tab>
              <v-tab>Data & Statistics</v-tab>
              <v-tab>Creativity index</v-tab>
            </v-tabs>

            <v-data-table
              :items="statistics"
              :options.sync="options"
              :server-items-length="statisticTotal"
              :loading="tableLoading"
              style="border: solid 1px #FF4F23">
              <template v-slot:header="{ item, index }">
                <thead class="white--text" style="background-color: #4F4F4F">
                  <tr>
                    <td width="5%">ลำดับ</td>
                    <td width="54%">ข้อมูลแสดงกราฟ</td>
                    <td width="12%">แสดงหน้า <br> Overview</td>
                    <td width="12%">แสดงหน้า <br> Data & Statistic</td>
                    <td width="12%">แสดงหน้า <br> Creativity index</td>
                    <td width="5%">แก้ไข</td>
                  </tr>
                </thead>
              </template>
              <template v-slot:item="{ item, index }">
                <tr>
                  <td>{{ index+1}}.</td>
                  <td class="text-start">{{ item.title_th }}</td>
                  <td><v-icon :class="{'cea-color':item.is_display_overview}">{{item.is_display_overview ? 'check':'close'}}</v-icon></td>
                  <td><v-icon :class="{'cea-color':item.is_display_industry}">{{item.is_display_industry ? 'check':'close'}}</v-icon></td>
                  <td><v-icon :class="{'cea-color':item.is_display_index}">{{item.is_display_index ? 'check':'close'}}</v-icon></td>
                  <td><InputForm :type="section" :edit="true" :param="item.id"></InputForm></td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>

        <v-layout v-else-if="section === 'report'" justify-center>
          <v-flex>
            <v-simple-table style="border: solid 1px #FF4F23">
              <thead class="white--text" style="background-color: #4F4F4F">
              <tr>
                <td width="10%">ลำดับ</td>
                <td width="80%">ข้อมูลแสดงรายงาน / วิจัย</td>
                <td width="10%">แก้ไข</td>
              </tr>
              </thead>
              <tbody>

                <tr v-for="(item, i) in articleList.data" :key="i">
                  <td>{{item.id}}.</td>
                  <td class="text-start">{{item.name_th}}</td>
                  <td><InputForm :type="section" :edit="true" :param="item.id"></InputForm></td>
                </tr>

              </tbody>
            </v-simple-table>

            <v-layout justify-end mt-3>
              <v-flex shrink v-if="paginationArticle.total > 0">
                <v-pagination v-model="paginationArticle.current"
                              :length="paginationArticle.total"
                              v-if="articleLoaded"
                              @input="onArticlePageChange"
                              circle
                              color="#FF4F23"
                              :total-visible="pageVisible"
                ></v-pagination>
              </v-flex>
              <v-flex shrink mr-3 v-else>
                ไม่พบรายการข้อมูล
              </v-flex>
            </v-layout>

          </v-flex>
        </v-layout>

        <v-layout v-else-if="section === 'cindex'" justify-center>
          <v-flex>
            <v-simple-table style="border: solid 1px #FF4F23">
              <thead class="white--text" style="background-color: #4F4F4F">
              <tr>
                <td>ลำดับ</td>
                <td>กลุ่มตัวชี้วัด</td>
                <td>แก้ไข</td>
              </tr>
              </thead>
              <tbody>

              <tr>
                <td>1.</td>
                <td class="text-start">กลุ่มตัวชี้วัดด้านทุนเชิงโครงสร้างและสถาบัน</td>
                <td><v-icon color="#FF4F23">edit</v-icon></td>
              </tr>
              <tr>
                <td>2.</td>
                <td class="text-start">กลุ่มตัวชี้วัดด้านทุนมนุษย์</td>
                <td><v-icon color="#FF4F23">edit</v-icon></td>
              </tr>
              <tr>
                <td>3.</td>
                <td class="text-start">กลุ่มตัวชี้วัดด้านทุนทางวัฒนธรรม</td>
                <td><v-icon color="#FF4F23">edit</v-icon></td>
              </tr>

              </tbody>
            </v-simple-table>
          </v-flex>
        </v-layout>

        <v-layout v-else-if="section === 'about'" justify-center>
          <v-flex xs12>

            <v-layout justify-center>
              <v-flex xs10>
                <v-layout column>
                  <v-flex mb-10 text-start>
                    <span class="cea-color txt-head">เกี่ยวกับเรา TH :</span>
                    <VueEditor useCustomImageHandler @image-added="handleImageAdded" v-model="about.description_th"></VueEditor>
                  </v-flex>
                  <v-flex mb-10 text-start>
                    <div class="cea-color txt-head">เกี่ยวกับเรา EN :</div>
                    <VueEditor useCustomImageHandler @image-added="handleImageAdded" v-model="about.description_en"></VueEditor>
                  </v-flex>
                  <v-flex>
                    <v-btn large color="#FF4F23" class="white--text" @click="saveAbout">บันทึก</v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

          </v-flex>
        </v-layout>

      </v-flex>
    </v-layout>

  </v-content>
</template>

<script>
  import Header from '../components/Header'
  import InputForm from "../components/InputForm"
  import { VueEditor } from "vue2-editor";
  import { mapState, mapActions } from 'vuex'
  import Service from '../services'
  import { domain } from '../services/Constants'
  import Loading from 'vue-loading-overlay'
  import axios from 'axios'

  export default {
    name: 'dashboard',
    components: {
      Header,
      InputForm,
      Loading,
      VueEditor
    },
    props: ['section'],
    data: () => ({
      drawer: null,
      // editor: ClassicEditor,
      about: {
        description_th: '',
        description_en: ''
      },
      dataParam: {},
      dataTab: 0,
      pageVisible: 8,
      paginationArticle: {
        current: 1,
        total: 1,
        itemPerPage: 10
      },
      articleLoaded: false,
      sectionLoaded: true,
      // Data table.
      tableLoading: true,
      options: {}
    }),
    computed: {
      ...mapState({
        userData: state => state.auth.userData,
        aboutDesc: state => state.dashboard.aboutDesc,
        articleList: state => state.dashboard.allArticlePaginate,
        statistics: state => state.statistic.statistics,
        statisticTotal: state => state.statistic.statisticTotal
      })
    },
    watch: {
      section: function (val) {
        this.initData(val);
        // re-render pagination
        this.articleLoaded = false;
        setTimeout(() => {
          this.articleLoaded = true;
        }, 1);
      },
      options: function (val) {
        this.initData(this.section);
      }
    },
    created() {
      this.dataParam.token = this.userData.token;
      this.onGetAboutDesc(this.dataParam).then(() => {
        this.about = this.aboutDesc
      });
      this.onGetAllArticlePaginate(this.dataParam).then(() => {
        this.onArticlePageChange();
      });
      this.onGetAllTsic(this.dataParam);
      this.onGetAllIndustries(this.dataParam);
      this.onGetAllIndex(this.dataParam);
      this.onGetAllTag(this.dataParam);
      this.onGetAllUnit(this.dataParam);
      this.onGetAllTopic(this.dataParam);
      this.onGetAllImported(this.dataParam);
      this.initData()
    },
    methods: {
      ...mapActions('dashboard',
              [
                    'onGetAboutDesc','onEditAboutDesc',
                    'onGetAllArticlePaginate','onGetArticle'
              ]),
      ...mapActions('tsic',['onGetAllTsic','onGetAllIndustries']),
      ...mapActions('index',['onGetAllIndex']),
      ...mapActions('data',['onGetAllTag','onGetAllUnit', 'onGetAllTopic', 'onGetAllImported']),
      ...mapActions('statistic',['populateStatistics','populateStatisticForm']),

      async initData () {

        const { itemsPerPage, page } = this.options;
        this.tableLoading = true;

        switch(this.dataTab) {
          case 1:
            await this.populateStatistics({
              per_page: itemsPerPage,
              page: page,
              is_display_overview: 1,
              order_by: 'ordering_overview',
              order_by_direction: 'asc'
            });
            break
          case 2:
            await this.populateStatistics({
              per_page: itemsPerPage,
              page: page,
              is_display_industry: 1,
              order_by: 'ordering_industry',
              order_by_direction: 'asc'
            });
            break
          case 3:
            await this.populateStatistics({
              per_page: itemsPerPage,
              page: page,
              is_display_index: 1,
              order_by: 'ordering_index',
              order_by_direction: 'asc'
            });
            break

          default:
            await this.populateStatistics({
              per_page: itemsPerPage,
              page: page
            });

        }

        this.tableLoading = false;

      },

      saveAbout() {
        this.about.id = 1;
        this.about.token = this.userData.token;
        this.onEditAboutDesc(this.about);
      },
      onArticlePageChange(page) {
        let data = { page: page, token: this.userData.token };

        this.paginationArticle.total = Math.ceil(this.articleList.total / this.paginationArticle.itemPerPage);

        Service.dashboard.getAllArticlePaginate(data).then((res) => {
          this.paginationArticle.current = res.current_page;
          this.articleList.data = res.data;
          this.articleLoaded = true;
        }).then(() => {
          this.sectionLoaded = false; // set finish loading
        })

      },
      handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
        var formData = new FormData();
        formData.append("image", file);

        axios({
          url: domain + '/api/add/image',
          method: "POST",
          data: formData,
          headers: { Authorization: `Bearer ${this.userData.token}` }
        }).then(result => {
                  let url = domain+'/'+result.data;  // Get url from response
                  Editor.insertEmbed(cursorLocation, "image", url);
                  resetUploader();
                }).catch(err => {
                  console.log(err);
                });

      },
      onTabChange(tab) {
        this.initData()
      }

    }
  }
</script>

<style scoped>

  .theme--light.v-data-table thead tr td:not(:last-child),
  .theme--light.v-data-table tbody tr td:not(:last-child) {
    border-right: solid 1px #D7D7D7 !important;
  }

</style>
